import React from "react";
import { Link } from "react-router-dom";
import '../../style_new.css';
const Footer = () => {
  return (
    
    <>

<div className="container-fluid bg-dark footer mt-5 pt-5 wow fadeIn" data-wow-delay="0.1s">
  <div className="container py-5">
    <div className="row g-5">
      <div className="col-lg-3 col-md-6">
        {/* Logo and Company Name Row */}
        <div className="d-flex align-items-center mb-4">
          <img
            src={'./images/fairvisionlogo.jpg'}
            alt="Fair Vision Ventures"
            style={{ height: "50px", width: "50px", marginRight: "10px" }}
          />
          <h1 className="text-white m-0 fs-4">FAIR VISION VENTURES</h1>
        </div>

        {/* <div className="d-flex pt-2">
          <a className="btn btn-square btn-outline-primary me-1" href="">
            <i className="fab fa-twitter"></i>
          </a>
          <a className="btn btn-square btn-outline-primary me-1" href="">
            <i className="fab fa-facebook-f"></i>
          </a>
          <a className="btn btn-square btn-outline-primary me-1" href="">
            <i className="fab fa-youtube"></i>
          </a>
          <a className="btn btn-square btn-outline-primary me-0" href="">
            <i className="fab fa-linkedin-in"></i>
          </a>
        </div> */}
      </div>

      <div className="col-lg-3 col-md-6">
        <h4 className="text-light mb-4">Address</h4>
        <p><i className="fa fa-map-marker-alt me-3"></i>Ghana Post: AG-0986-1883</p>
        <p><i className="fa fa-map-marker-alt me-3"></i>Melcom Road,Sokoban,Ghana</p>
        <p><i className="fa fa-phone-alt me-3"></i>+233 244429129</p>
        <p><i className="fa fa-envelope me-3"></i>info@fairvision.org</p>
      </div>

      <div className="col-lg-3 col-md-6">
        <h4 className="text-light mb-4">Quick Links</h4>
        <Link to="/" className="btn btn-link">Home</Link>
        <Link to="/about-us" className="btn btn-link">About</Link>
        <Link to="/contact-us" className="btn btn-link">Contact Us</Link>
        <Link to="/blogs" className="btn btn-link">Blogs</Link>
        <Link to="/sign-up" className="btn btn-link">Sign Up</Link>
      </div>
      <div className="col-lg-3 col-md-6">
        <h4 className="text-light mb-4">Contact Us</h4>
        <p><i className="fa fa-phone-alt me-3"></i>+233 244429129</p>
        <p><i className="fa fa-phone-alt me-3"></i>+233 266198452</p>
      </div>
    </div>
  </div>

  <div className="container-fluid copyright">
    <div className="container">
      <div className="row">
        <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
          &copy; <a href="#">Fair Vision Ventures</a>, All Right Reserved. 2025
        </div>
        <div className="col-md-6 text-center text-md-end">
          Designed By Stellar Charter Ltd
        </div>
      </div>
    </div>
  </div>
</div>


    </>
  );
};
  
export default Footer;